import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=c9b08b90&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=c9b08b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b08b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9b08b90')) {
      api.createRecord('c9b08b90', component.options)
    } else {
      api.reload('c9b08b90', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=c9b08b90&scoped=true&", function () {
      api.rerender('c9b08b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4eLUplb2NmATq/JS/comp/PopupDialog.vue"
export default component.exports